import "react-international-phone/style.css"

import { ComponentPropsWithoutRef } from "react"
import { PhoneInput } from "react-international-phone"
import { cva, RecipeVariantProps } from "styled-system/css"
import { styled } from "styled-system/jsx"
import { SystemStyleObject } from "styled-system/types"

const inputStyle = cva({
  base: {
    "--react-international-phone-border-radius": "8px",
    "--react-international-phone-border-color": "transparent",
    "--react-international-phone-background-color": "white",
    "--react-international-phone-text-color": "#0008",
    "--react-international-phone-selected-dropdown-item-background-color":
      "#E6EBFF",
    "--react-international-phone-country-selector-background-color-hover":
      "#E6EBFF",

    height: "45px",
    transition: "background 280ms",
    boxShadow: "0px 1px 3px 1px #00000026",
    borderRadius: "8px",
    background: "white",
    width: "100%",

    "&:focus-within": {
      background: "white",
    },

    "&:not(:focus-within):is(:hover, :active)": {
      background: "#E6EBFF",
    },

    "& input": {
      "&:not(:focus)::placeholder": {
        color: "#0008",
      },

      "&:focus": {
        outline: "none",
      },

      "&:focus::placeholder": {
        color: "#8596EE",
      },
    },
  },
  defaultVariants: {},
})

export type InputVariants = RecipeVariantProps<typeof inputStyle>
const Input = styled(PhoneInput, inputStyle, {
  defaultProps: {
    defaultCountry: "es",
    preferredCountries: ["es"],
    countrySelectorStyleProps: {
      buttonStyle: {
        height: "45px",
        transition: "background 280ms",
        paddingLeft: "8px",
      },
    },
    inputStyle: {
      height: "45px",
      transition: "background 280ms",
      minWidth: "120px",
      flex: "1",
      border: "none",
      color: "inherit",
      fontSize: "inherit",
      background: "transparent",
    },
  },
})

export { Input as PhoneInput }

export type InputProps = {
  css: SystemStyleObject
} & InputVariants &
  ComponentPropsWithoutRef<typeof PhoneInput>
